const useFloatingActionButtonStyles = () => {
    return {
        floatingContainer: {
            position: 'fixed',
            bottom: 0,
            // background: { xs: ' #25292D4D', sm: ' #25292D4D', md: ' #25292D4D', lg: 'unset' },
            left: { xs: 0, sm: 0, md: 0, lg: '50%' },
            right: { xs: 0, sm: 0, md: 0, lg: 'unset' },
            width: { xs: '100%', sm: '100%', md: '100%', lg: 'auto' },
            transform: {
                xs: 'none',
                sm: 'none',
                md: 'none',
                lg: 'translateX(-50%)'
            },
            backdropFilter: 'blur(8px)',
            zIndex: 1300
        },
        buttonContainer: {
            display: 'flex',
            gap: 1,
            justifyContent: 'center'
        },
        button: {
            fontWeight: 500,
            fontSize: '15px'
        }
    };
};
export default useFloatingActionButtonStyles;
